module.exports = __webpack_public_path__ + "img/livro_reclamacoes.7eb09fd0.png";